/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EBoxType } from '.';

export const PingAndResetSupportedDevices = [EBoxType.VDD, EBoxType.Xirgo, EBoxType.Calamp, EBoxType.CalampAsset, EBoxType.VDD2];
